/** --------------------------------------------------
* 
*   THEME SCRIPT
*
*   TABLE OF CONTENTS
*   document ready
*
*  -------------------------------------------------- */

(function($) {

  "use strict";

  /** --------------------------------------------------
  *   #document ready
  *   -------------------------------------------------- */


  $(function() {
    if($(".paragraph--type--two-x-half-chapter").hasClass("background-image")) {
      console.log("has");
      $(".field--name-field-half-chapter-1").each(function(){
        var img = $(this).find("img")
        var pic = img.prop("src");
        $(this).attr("style","background-image: url(" + pic + ")");
        img.remove();
      });
      $(".field--name-field-half-chapter-2").each(function(){
        var img = $(this).find("img")
        var pic = img.prop("src");
        $(this).attr("style","background-image: url(" + pic + ")");
        img.remove();
      });
    }
  });

  $(function() {
    $(".field--name-field-faq-question").click(function(){
      $(this).next('.field--name-field-faq-answer').fadeToggle();
    });
  }); 

  $(function() {
    $(".dark").parent().addClass("dark-bg");
    $(".light").parent().addClass("light-bg");
  });

  /// MENU HAMBURGER ///

  $(".hamburger").click(function() {
    $("#block-rubychocolate-mainnavigation").slideToggle().toggleClass("menu-visible");
    $(".hamburger").hide();
    $(".hide-menu").show();
  });

  $(".hide-menu").click(function() {
    $("#block-rubychocolate-mainnavigation").slideToggle().toggleClass("menu-visible");
    $(".hide-menu").hide();
    $(".hamburger").show();
  });


})(jQuery);
